<template>
  <el-dialog
    class="dialog-inner-scroller" :model-value="visible" :before-close="() => {
      emit('close');
    }" width="800"
  >
    <template #header>
      <div class="my-header">
        <h4 class="px-2 pb-3 text-xl text-[var(--color-text-primary)] font-semibold">
          账号充值({{ data.serverName }}-支付宝记账簿入账)
        </h4>
      </div>
    </template>

    <div class="px-2 pb-3">
      <div>
        <img
          class="w-full  h-[200px]"
          src="https://lg5-prod-1314932667.cos.ap-nanjing.myqcloud.com/web-example/%E6%94%AF%E4%BB%98%E5%AE%9D%E5%85%85%E5%80%BC" alt="支付宝记账簿入账"
        >
      </div>
      <div class="line mt-4">
        <div class="label">
          可入账银行卡
        </div>
        <div class="value text-[var(--color-primary-90)!important] cursor-pointer" @click="handleViewCard">
          查看
        </div>
      </div>
      <div class="line">
        <div class="label">
          资金通道
        </div>
        <div class="value">
          支付宝记账簿
        </div>
      </div>
      <div class="line">
        <div class="label">
          当前余额
        </div>
        <div class="value">
          {{ data.availableBalance }}元
        </div>
      </div>
      <div class="tit">
        <span class="text-[var(--color-danger)]">户名、账号、支行、开户地为必填信息且不可填写错误，</span>转账类型、账户类型选填，具体以各银行为准
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          户名
          <span class="spanMust">必填</span>
        </div>
        <div class="value">
          支付宝（中国）网络技术有限公司
        </div>
        <div class="flex text-[var(--color-primary)] cursor-pointer" @click="copyTxt('支付宝（中国）网络技术有限公司')">
          <svg-icon icon="lsicon:batch-check-outline" />&nbsp;复制
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          账号
          <span class="spanMust">必填</span>
        </div>
        <div class="value">
          {{ data?.alipayRechargeAccount?.cardNo }}
        </div>
        <div class="flex text-[var(--color-primary)] cursor-pointer" @click="copyTxt(data?.alipayRechargeAccount?.cardNo)">
          <svg-icon icon="lsicon:batch-check-outline" />&nbsp;复制
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          支行
          <span class="spanMust">必填</span>
        </div>
        <div class="value">
          支付宝—备付金账户
        </div>
        <div class="flex text-[var(--color-primary)] cursor-pointer" @click="copyTxt('支付宝—备付金账户')">
          <svg-icon icon="lsicon:batch-check-outline" />&nbsp;复制
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          对应开户行号
          <span class="spanMust">必填</span>
        </div>
        <div class="value">
          991290000015
        </div>
        <div class="flex text-[var(--color-primary)] cursor-pointer" @click="copyTxt('991290000015')">
          <svg-icon icon="lsicon:batch-check-outline" />&nbsp;复制
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          开户地
          <span class="spanMust">必填</span>
        </div>
        <div class="value">
          上海市-上海市
        </div>
        <div class="flex text-[var(--color-primary)] cursor-pointer" @click="copyTxt('上海市-上海市')">
          <svg-icon icon="lsicon:batch-check-outline" />&nbsp;复制
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          转账类型
          <span class="span">选填</span>
        </div>
        <div class="value">
          备付金转账/向支付机构转账
        </div>
      </div>
      <div class="line mt-[12px]">
        <div class="label">
          账户类型
          <span class="span">选填</span>
        </div>
        <div class="value">
          支付机构备付金集中存管账户
        </div>
      </div>
      <div class="flex justify-end">
        <el-button type="" @click="emit('close')">
          返回
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { IFinanceWallet } from '@core/main/types';
import { SvgIcon } from '@vue3/components';
import { copyToClipboard } from '@core/tools';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';

const emit = defineEmits(['close', 'confirm']);
const router = useRouter();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object as PropType<IFinanceWallet>,
    default: () => ({}),
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

function copyTxt(txt: string) {
  copyToClipboard(txt);
  ElMessage.success('复制成功');
}

function handleViewCard() {
  router.push({
    name: 'FinanceIncomingAccount',
    query: { serverId: props.data.serverId },
  });
}
</script>

<style lang="scss" scoped>
.info-mini {
  font-size: 12px;
  line-height: 21px;
}

.info-title {
  font-size: 16px;
  font-weight: 700;
}

.info-card {
  border-radius: 8px;
  border: 1px var(--color-border-base) solid;
  margin: 16px 0;
  box-sizing: border-box;
  padding: 10px 18px;
  line-height: 22px;

  span {
    color: var(--color-text-primary);

    &.info-tag {
      width: 100px;
      text-align: right;
      display: inline-block;
      color: var(--color-text-secondary);
      margin-right: 10px;
    }
  }
}

.line {
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  .label {
    width: 180px;
    text-indent: 20px;
    text-align: right;

    .spanMust {
      width: 37px;
      height: 20px;
      font-size: 12px;
      background: var(--color-danger-10);
      border-radius: 2px 2px 2px 2px;
      border: 1px solid var(--color-danger-20);
      padding: 2px 4px;
      color: var(--color-danger)
    }

    .span {
      width: 37px;
      height: 20px;
      font-size: 12px;
      background: var(--color-primary-10);
      border-radius: 2px 2px 2px 2px;
      border: 1px solid var(--color-primary-20);
      padding: 2px 4px;
      color: var(--color-primary-70);
    }

  }

  .value {
    margin-left: 20px;
    flex: 1;
    color: var(--color-text-primary)
  }
}

.tit {
  background-color: var(--color-primary-10);
  padding: 10px 0;
  text-indent: 20px;
  border: 1px solid var(--color-primary-20);
}
</style>
